import { Divider } from '@mui/material';
import { useMemo } from 'react';
import { createActiveFilterObject } from '../../../utils';
import { FilterItem } from '../../../interfaces/filterOptions.interface';
import TableFiltersItems from '../../../components/Table/TableRenderFiltersItems';
import TableSearch from '../../../components/Table/TableSearch';
import { ActiveFilters } from '../../../hooks/useTablePageParams';
import { TALENTS_PAGE_FILTERS } from '../talentsListPageFilters';

type TalentsFilterProps = {
  activeFilters: ActiveFilters,
  onChangeFilter: (filterName: string, newValue: string[]) => void,
}

const TalentsFilters = ({
  activeFilters,
  onChangeFilter,
}: TalentsFilterProps): JSX.Element => {
  const handleSearch = (searchValue: string): void => {
    onChangeFilter(TALENTS_PAGE_FILTERS.QUERY, [searchValue]);
  };

  const handleCompaniesChanged = (newCompanies: string[]): void => {
    onChangeFilter(TALENTS_PAGE_FILTERS.COMPANY, newCompanies);
  };

  const handleDelete = (filterItem: FilterItem) => {
    switch (filterItem.field) {
      case TALENTS_PAGE_FILTERS.QUERY: {
        handleSearch('');
        break;
      }
      case TALENTS_PAGE_FILTERS.COMPANY: {
        handleCompaniesChanged(activeFilters[TALENTS_PAGE_FILTERS.COMPANY]
          .filter((item: string) => {
            return item !== filterItem.value;
          }));

        break;
      }
      default: {
        // noop
      }
    }
  };

  const getActiveFilters = useMemo((): FilterItem[] => {
    const filters: FilterItem[] = [];

    if (activeFilters[TALENTS_PAGE_FILTERS.QUERY]) {
      activeFilters[TALENTS_PAGE_FILTERS.QUERY].forEach((item: string) => {
        if (item.length > 0) {
          filters.push(
            createActiveFilterObject(
              TALENTS_PAGE_FILTERS.QUERY,
              'Search',
              item,
            ),
          );
        }
      });
    }

    // IMPORTANT:
    // WE CANNOT LOAD DATA FROM COMPANIES LIST BECAUSE IT'S FILTERED
    // AND DOESN'T CONTAIN ALL THE COMPANIES !!
    // so, filters will be disappearing when filtering companies !
    if (activeFilters[TALENTS_PAGE_FILTERS.COMPANY]) {
      activeFilters[TALENTS_PAGE_FILTERS.COMPANY].forEach((item: string) => {
        if (item.length > 0) {
          filters.push(
            createActiveFilterObject(
              TALENTS_PAGE_FILTERS.COMPANY,
              'Company',
              item,
            ),
          );
        }
      });
    }

    return filters;
  }, [activeFilters]);

  return (
    <>
      <TableSearch handleSearch={ handleSearch } />
      <Divider />
      <TableFiltersItems filters={ getActiveFilters } onDelete={ handleDelete } />
    </>
  );
};

export default TalentsFilters;
